import { EXTERNAL_LINK_TYPE } from "@stadium/shared/src/constants/stores/routes";

import LinkWithLangClient from "@components/swagmagic/dynamic/slices/client-link-with-lang";
import ProfileDropdown from "@components/swagmagic/profile-dropdown";
import { HeaderCta } from "@components/swagmagic/header/type";

import styles from "./main.module.scss";

export interface HeaderMobileMenuActionsProps {
  profileText?: string;
  ctaButtonData?: HeaderCta;
}

export default function HeaderMobileMenuActions({
  ctaButtonData,
}: Readonly<HeaderMobileMenuActionsProps>) {
  return (
    <div className={styles.bottomSection}>
      <ProfileDropdown />
      <div className={styles.ctaContainer}>
        <LinkWithLangClient
          type={EXTERNAL_LINK_TYPE}
          data={{ url: ctaButtonData?.btnLink || "/" }}
          className={styles.ctaButton}
          target={ctaButtonData?.openInNewTab ? "_blank" : "_self"}
          showExternalLinkIcon={ctaButtonData?.openInNewTab}
        >
          {ctaButtonData?.btnText}
        </LinkWithLangClient>
      </div>
    </div>
  );
}
